import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaHome } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Navbar from '../components/Layout/Navbar';
import TopBar from '../components/Layout/TopBar';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-[#001B56]">
      <TopBar />
      <div className="sticky top-4 z-50 flex flex-col items-center w-full">
        <div className="relative w-[90vw] max-w-2xl">
          <Navbar />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 py-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-[#00238D] shadow-lg p-8 rounded-lg"
        >
          <div className="flex items-center gap-3 mb-8">
            <FaShieldAlt className="text-3xl text-blue-600" />
            <h1 className="text-3xl font-bold">Mentions Légales</h1>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-white mb-4">1. Informations légales</h2>
            <div className="mb-6">
              <p className="mb-4"><strong>Raison sociale :</strong> Entente Feignies Aulnoye Football Club (EFAFC)</p>
              <p className="mb-4"><strong>Adresse :</strong> [Adresse du club]</p>
              <p className="mb-4"><strong>Téléphone :</strong> [Numéro de téléphone]</p>
              <p className="mb-4"><strong>Email :</strong> contact@efafc.fr</p>
              <p className="mb-4"><strong>Numéro SIRET :</strong> [Numéro SIRET]</p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">2. Directeur de la publication</h2>
            <p className="mb-6">
              Le directeur de la publication est le président du club, [Nom du président].
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">3. Hébergement</h2>
            <div className="mb-6">
              <p className="mb-4"><strong>Hébergeur :</strong> Firebase (Google LLC)</p>
              <p className="mb-4"><strong>Adresse :</strong> 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA</p>
            </div>

            <h2 className="text-2xl font-bold text-white mb-4">4. Propriété intellectuelle</h2>
            <p className="mb-6">
              L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. 
              Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">5. Responsabilité</h2>
            <p className="mb-6">
              Les informations contenues sur ce site sont aussi précises que possible et le site est périodiquement remis à jour, 
              mais peut toutefois contenir des inexactitudes, des omissions ou des lacunes. Si vous constatez une lacune, erreur ou ce qui parait 
              être un dysfonctionnement, merci de bien vouloir le signaler par email en décrivant le problème de la manière la plus précise possible.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">6. Liens hypertextes</h2>
            <p className="mb-6">
              Les liens hypertextes mis en place dans le cadre du présent site web en direction d'autres ressources présentes sur le réseau Internet, 
              et notamment vers ses partenaires ont fait l'objet d'une autorisation préalable, expresse et écrite.
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">7. Collecte et traitement de données</h2>
            <p className="mb-6">
              Conformément aux dispositions de la loi n° 78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, 
              modifiée par la loi n° 2004-801 du 6 août 2004, et du Règlement Général sur la Protection des Données (RGPD), 
              l'utilisateur dispose d'un droit d'accès, de rectification et de suppression des informations qui le concernent.
            </p>

            <p className="mb-6">
              Pour exercer ce droit, envoyez un message à l'adresse suivante : contact@efafc.fr
            </p>

            <h2 className="text-2xl font-bold text-white mb-4">8. Droit applicable et juridiction</h2>
            <p className="mb-6">
              Tout litige en relation avec l'utilisation du site www.efafc.fr est soumis au droit français. 
              Il est fait attribution exclusive de juridiction aux tribunaux compétents de [Ville].
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-gray-200">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <FaHome />
              Retour à l'accueil
            </Link>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default MentionsLegales;